var map = {
	"./en": [
		8792,
		411
	],
	"./en-us": [
		817,
		817
	],
	"./en-us.ts": [
		817,
		817
	],
	"./en.ts": [
		8792,
		411
	],
	"./fr": [
		7523,
		523
	],
	"./fr.ts": [
		7523,
		523
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3859;
module.exports = webpackAsyncContext;